/**
 * Analytics display thresholds — Phase 2a (Observation Layer)
 * ───────────────────────────────────────────────────────────
 * Locked constant. Any analytics/charting surface that aggregates
 * sample data MUST consult MIN_SAMPLE_FOR_DISPLAY before rendering
 * a numeric value, percentage, or trend.
 *
 * When sample size is below the threshold, surface "Not enough data
 * yet" instead of a misleading number. Mirrors the rule already
 * enforced in `getContractorOfferMetrics` and `executionScore`
 * (sample < 3 → null).
 *
 * Hard rules:
 *   • This is a display threshold only — never gate writes on it.
 *   • Do not lower without an explicit governance decision.
 *   • Do not duplicate this constant in a feature module — import it.
 */

export const MIN_SAMPLE_FOR_DISPLAY = 3;

/**
 * Helper: returns true when a sample size is sufficient to render.
 * Centralizes the comparison so future tightening (e.g. raising to 5)
 * is a one-line change.
 */
export function hasDisplayableSample(n: number | null | undefined): boolean {
  return typeof n === "number" && n >= MIN_SAMPLE_FOR_DISPLAY;
}
